export default __webpack_public_path__ + "static/novotel-11c01601fe6b9cc13521bdfbdeb59afd.png";